import { UnitRequest } from '@gtpl/shared-models/common-models';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { AllGrnReportResponse, AllGrnResponseModel, BatchNumRequest, GrnDetailViewResponseModel, GrnIDRequest, GrnInspectionreq, GrnItemIdRequest, GrnItemReceivedQtyResponse, GrnItemReturnResponse, GrnNumberResponseModel, GrnQtyResponseModel, GrnReturnAutoFillModel, LotNumRequest, QuantityDeviationRequest, RmCountRequest, RmRatesReportReq, RmReceivingReportReq, getMonthWisePurchaseRequest, grnIdreq, grnReportreq } from '@gtpl/shared-models/procurement-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post,Get, UploadedFile, UseInterceptors } from '@nestjs/common';
import { ApiConsumes, ApiTags,ApiBody } from '@nestjs/swagger';
import { PurchaseOrderIdRequest } from '../po-creation/dto/po-id.request';
import { GrnItemReceivedQtyRequest } from './dto/grn-item-received-qty-request';
import { GrnQtyRequest } from './dto/grn-qty-request';
import { GrnIdRequest } from './dto/grn-request';
import { grnResponse } from './dto/grn-response';
import { GrnDto } from './dto/grn.dto';
import { invoiceNumberRequest } from './dto/invoice-number-req';
import { GrnReportRequest } from './grn-report-request';
import { GrnService } from './grn.service';
import { CommonResponse as Response } from '@gtpl/shared-models/sale-management';
import { FileUploadResponse } from '@gtpl/shared-models/logistics';
import { FileInterceptor } from '@nestjs/platform-express';
import { extname, join } from 'path';
import { diskStorage } from 'multer';
import * as fs from 'fs-extra';
import { IdRequest } from '@gtpl/shared-models/gtpl';
import { PayablesDashboardReq } from '@gtpl/shared-models/raw-material-procurement';



@Controller('grn')
@ApiTags('grn')

export class GrnController {
  constructor(
    private grnService: GrnService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler,
  ) { }

  /**
 * creates or a GRN
 * @param saleGrnDto Grn DTO
 * @returns GrnResponse
 */
  @Post('/createGrn')
  async createGrn(@Body() grnDto: GrnDto): Promise<grnResponse> {
    try {
      return await this.grnService.createGrn(grnDto, false);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(grnResponse, error);
    }
  }

  /**
* get GRN Qty against PO
* @param poIdReq poIdReq
* @returns GrnResponse
*/
  @Post('/getGrnQtyByPoId')
  async getGrnQtyByPoId(@Body() poIdReq: GrnQtyRequest): Promise<GrnQtyResponseModel> {
    try {
      return await this.grnService.getGrnQtyByPoId(poIdReq);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(GrnQtyResponseModel, error);
    }
  }

  /**
* get GRN details against PO
* @param poIdReq poIdReq
* @returns GrnResponse
*/
  @Post('/getGrnByPoId')
  async getGrnByPoId(@Body() poIdReq: GrnQtyRequest): Promise<any> {
    try {
       return await this.grnService.getGrnByPoId(poIdReq);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(grnResponse, error);
    }
  }

  /**
* get GRN details 
* @param 
* @returns AllGrnResponseModel
*/
  @Post('/getAllGrnDetails')
  async getAllGrnDetails(@Body() req?: UnitRequest): Promise<AllGrnResponseModel> {
    try {
      return await this.grnService.getAllGrnDetails(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllGrnResponseModel, error);
    }
  }

    /**
* get GRN details 
* @param 
* @returns AllGrnResponseModel
*/
@Post('/getAllGrnData')
async getAllGrnData(@Body() req?: UnitRequest): Promise<AllGrnResponseModel> {
  try {
    return await this.grnService.getAllGrnData(req);
  } catch (error) {
    return this.applicationExceptionHandler.returnException(AllGrnResponseModel, error);
  }
}

  

  /**
* get PO against POId
* @param poIdReq poIdReq
* @returns GrnResponse
*/
  @Post('/getGrnDataById')
  async getGrnDataById(@Body() grnIdReq: GrnIdRequest): Promise<GrnDetailViewResponseModel> {
    try {
      return await this.grnService.getGrnDataById(grnIdReq);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(GrnDetailViewResponseModel, error);
    }
  }

  @Post('/getGrnDataByIdForReturn')
  async getGrnDataByIdForReturn(@Body() grnIdReq: GrnIdRequest): Promise<GrnItemReturnResponse> {
    try {
      return await this.grnService.getGrnDataByIdForReturn(grnIdReq);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(GrnItemReturnResponse, error);
    }
  }

  @Post('getAllActiveGrnNumbers')
  async getAllActiveGrnNumbers(@Body() req?: UnitRequest): Promise<GrnNumberResponseModel> {
    try {
      return await this.grnService.getAllActiveGrnNumbers(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(GrnNumberResponseModel, error);
    }
  }

  @Post('getGrnReturnAutoFillDataByGrnId')
  async getGrnReturnAutoFillDataByGrnNumber(@Body() grnIdReq: GrnIdRequest): Promise<GrnReturnAutoFillModel> {
    try {
      return this.grnService.getGrnReturnAutoFillDataByGrnNumber(grnIdReq);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(GrnReturnAutoFillModel, error);
    }
  }

  @Post('getGrnItemReceivedQtyByGrnIdandItem')
  async getGrnItemReceivedQtyByGrnIdandItem(@Body() grnItemReq: GrnItemReceivedQtyRequest): Promise<GrnItemReceivedQtyResponse> {
    try {
      return this.grnService.getGrnItemReceivedQtyByGrnIdandItem(grnItemReq);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(GrnItemReceivedQtyResponse, error);
    }
  }
  @Post('/getAllGrnReport')
  async getAllGrnReport(@Body() req?: GrnReportRequest): Promise<AllGrnReportResponse> {
    try {
      return await this.grnService.getAllGrnReport(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllGrnReportResponse, error);
    }
  }
  @Post('getSoDropForGrnReport')
  async getSoDropForGrnReport(@Body() req: UnitRequest): Promise<CommonResponse> {
      try {
          return await this.grnService.getSoDropForGrnReport(req);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }
  @Post('getPoDropForGrnReport')
  async getPoDropForGrnReport(@Body() req: UnitRequest): Promise<CommonResponse> {
      try {
          return await this.grnService.getPoDropForGrnReport(req);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }
  @Post('getItemSubDropForGrnReport')
  async getItemSubDropForGrnReport(@Body() req: UnitRequest): Promise<CommonResponse> {
      try {
          return await this.grnService.getItemSubDropForGrnReport(req);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }
  @Post('getItemDropForGrnReport')
  async getItemDropForGrnReport(@Body() req: UnitRequest): Promise<CommonResponse> {
      try {
          return await this.grnService.getItemDropForGrnReport(req);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }
  @Post('getVendorDropForGrnReport')
  async getVendorDropForGrnReport(@Body() req: UnitRequest): Promise<CommonResponse> {
      try {
          return await this.grnService.getVendorDropForGrnReport(req);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }

  @Post('getgrnUsage')
  async getGrnUsage():Promise<any>{
  try{
      return await this.grnService.getGrnUsage();
   }catch(error){
       return this.applicationExceptionHandler.returnException(CommonResponse,error)
   }
  }

  @Post('/getTransferredSosDataForGrnGrid')
  async getTransferredSosDataForGrnGrid(@Body() req?: UnitRequest): Promise<AllGrnReportResponse> {
    try {
      return await this.grnService.getTransferredSosDataForGrnGrid(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllGrnReportResponse, error);
    }
  }
  

  @Post('/grninfoforpending')
  async grninfoforpending(@Body() req?: UnitRequest): Promise<CommonResponse> {
    try {
      return await this.grnService.grninfoforpending(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getLocationMappedGrns')
  async getLocationMappedGrns(@Body() req:invoiceNumberRequest): Promise<CommonResponse> {
    try {
      return await this.grnService.getLocationMappedGrns(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/saveGrnInspection')
  async saveGrnInspection(@Body() req?:GrnInspectionreq): Promise<CommonResponse> {
    try {
      console.log(req,"controllerrrrrrrrrrrrr");
      
      return await this.grnService.saveGrnInspection(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
    
  }
  @Post('/getGrnitemById')
  async getGrnitemById(@Body() req?:grnIdreq): Promise<CommonResponse> {
    try {
      console.log(req,"controllerrrrrrrrrrrrr");
      
      return await this.grnService.getGrnitemById(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
    
  }
  @Post('/getGrnReportData')
  async getGrnReportData(@Body() req?:grnReportreq): Promise<CommonResponse> {
    try {
   
      return await this.grnService.getGrnReportData(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
    
  }
  @Post('/getGrnReportPoNum')
  async getGrnReportPoNum(): Promise<CommonResponse> {
    try {
      
      return await this.grnService.getGrnReportPoNum();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
    
  }
  @Post('/getGrnReportExcel')
  async getGrnReportExcel(): Promise<CommonResponse> {
    try {
      
      return await this.grnService.getGrnReportExcel();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
    
  }

  @Post('/getInspectedGRNNumbersDropdown')
  async getInspectedGRNNumbersDropdown(): Promise<CommonResponse> {
    try {  
      return await this.grnService.getInspectedGRNNumbersDropdown();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
    
  }

  @Post('/getInspectedGrnInfo')
  async getInspectedGrnInfo(@Body() req:GrnIdRequest): Promise<CommonResponse> {
    try {
      return await this.grnService.getInspectedGrnInfo(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
    
  }
  @Post('/getRmWeighment')
  async getRmWeighment(@Body() req:GrnItemIdRequest): Promise<CommonResponse> {
    try {
      return await this.grnService.getRmWeighment(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
    
  }
  @Post('/getQuantityDeviation')
  async getQuantityDeviation(@Body() req:QuantityDeviationRequest): Promise<CommonResponse> {
    try {
      return await this.grnService.getQuantityDeviation(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
    
  }
  @Post('/getQuantityDeviationIndents')
  async getQuantityDeviationIndents(): Promise<CommonResponse> {
    try {
      return await this.grnService.getQuantityDeviationIndents();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
    
  }
  @Post('/getQuantityDeviationFarmers')
  async getQuantityDeviationFarmers(): Promise<CommonResponse> {
    try {
      return await this.grnService.getQuantityDeviationFarmers();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
    
  }
   @Post('/getQuantityDeviationBatches')
  async getQuantityDeviationBatches(): Promise<CommonResponse> {
    try {
      return await this.grnService.getQuantityDeviationBatches();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
    
  }
  @Post('/getPuchareAnalysisReport')
  async getPuchareAnalysisReport(@Body() req:BatchNumRequest): Promise<Response> {
    try {
      return await this.grnService.getPuchareAnalysisReport(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(Response, error);
    }
    
  }
  @Post('/getPuchareAnalysisData')
  async getPuchareAnalysisData(@Body() req:BatchNumRequest): Promise<CommonResponse> {
    try {
      return await this.grnService.getPuchareAnalysisData(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
    
  }
  @Post('/getAllBatchesForReWeighment')
  async getAllBatchesForReWeighment(@Body() req:IdRequest): Promise<CommonResponse> {
    try {
      return await this.grnService.getAllBatchesForReWeighment(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
    
  }
  @Post('/getAllBatchesForLive')
  async getAllBatchesForLive(@Body() req:IdRequest): Promise<CommonResponse> {
    try {
      return await this.grnService.getAllBatchesForLive(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
    
  }
  @Post('/getRmPriceByCount')
  async getRmPriceByCount(@Body() req:RmCountRequest): Promise<CommonResponse> {
    try {
      return await this.grnService.getRmPriceByCount(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
    
  }
  @Post('/getLivePurchase')
  async getLivePurchase(@Body() req:BatchNumRequest): Promise<CommonResponse> {
    try {
      return await this.grnService.getLivePurchase(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
    
  }
  @Post('/getRmRecievingReportData')
  async getRmRecievingReportData(@Body() req:RmReceivingReportReq): Promise<CommonResponse> {
    try {
      return await this.grnService.getRmRecievingReportData(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
    
  }
  @Post('/getRmRecievingReportSummary')
  async getRmRecievingReportSummary(@Body() req:RmReceivingReportReq): Promise<Response> {
    try {
      return await this.grnService.getRmRecievingReportSummary(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(Response, error);
    }
  }
  @Post('/getRmRates')
  async getRmRates(@Body() req:any[]): Promise<CommonResponse> {
    try {
      return await this.grnService.getRmRates(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getGrnData')
  async getGrnData(): Promise<CommonResponse> {
    try {
      
      return await this.grnService.getGrnData();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  
  @Post('getInspectionDetails')
  async getInspectionDetails() :Promise<CommonResponse>{
    try{
      return await this.grnService.getInspectionDetails();

    }catch(error){
      return this.applicationExceptionHandler.returnException(CommonResponse,error);
    }
  }
  @Post('getStatusDetails')
  @ApiBody({type:GrnItemIdRequest})
  async getStatusDetails(@Body() req:GrnItemIdRequest) :Promise<CommonResponse>{
    try{
      return await this.grnService.getStatusDetails(req);

    }catch(error){
      return this.applicationExceptionHandler.returnException(CommonResponse,error);
    } 

}
  @Post('/getRawMaterialGrn')
  async getRawMaterialGrn(@Body() req:GrnIDRequest): Promise<CommonResponse> {
    try {
      return await this.grnService.getRawMaterialGrn(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/grnFileUpload')
  @UseInterceptors(FileInterceptor('file', {
      limits: { files: 1 },
      storage: diskStorage({
          destination: async (req, file, callback) => {
              const uploadDir = join(__dirname, '../../../../', '/tally-integration/grn-files/');
              // Check if the directory exists, if not, create it
              if (!(await fs.pathExists(uploadDir))) {
                  try {
                      await fs.ensureDir(uploadDir);
                  } catch (err) {
                      console.error('Error creating directory:', err);
                  }
              }
              callback(null, uploadDir);
          },
          filename: (req, file, callback) => {
              const name = file.originalname.split('.')[0];
              const fileExtName = extname(file.originalname);
              const randomName = Array(4)
                  .fill(null)
                  .map(() => Math.round(Math.random() * 16).toString(16))
                  .join('');
              callback(null, `${name}-${randomName}${fileExtName}`);
          },
      }),
      fileFilter: (req, file, callback) => {
          if (!file.originalname.match(/\.(csv|xlsx|xls|pdf|zip)$/)) {
              return callback(new Error('Only csv, xlsx, xls, pdf files are allowed!'), false);
          }
          callback(null, true);
      },
  }))
  async grnFileUpload(@UploadedFile() file, @Body() uploadData: any): Promise<FileUploadResponse> {
      console.log(file, '****');
      try {
          return await this.grnService.updatePath(file.path, file.filename, uploadData.grnId);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(FileUploadResponse, error);
      }
  }
  
  @Post('/getGrnPrint')
  async getGrnPrint(@Body() req:GrnIDRequest): Promise<CommonResponse> {
      try {
          return await this.grnService.getGrnPrint(req);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }
  @Post('/getAllBatchesAgainstMainLot')
  async getAllBatchesAgainstMainLot(@Body() req:BatchNumRequest): Promise<Response> {
    try {
      return await this.grnService.getAllBatchesAgainstMainLot(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(Response, error);
    }
    
  }
  @Post('/getRmRecievingReportOthersSummary')
  async getRmRecievingReportOthersSummary(@Body() req:RmReceivingReportReq): Promise<Response> {
    try {
      return await this.grnService.getRmRecievingReportOthersSummary(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(Response, error);
    }
  }
  @Post('/getRmRateReportData')
  async getRmRateReportData(@Body() req?:RmRatesReportReq): Promise<Response> {
    try {
      return await this.grnService.getRmRateReportData(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(Response, error);
    }
  }
  @Post('/getRmRateReportCountRanges')
  async getRmRateReportCountRanges(): Promise<Response> {
    try {
      return await this.grnService.getRmRateReportCountRanges();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(Response, error);
    }
  }
  @Post('/getMonthWisePurchaseAnalysisReport')
  async getMonthWisePurchaseAnalysisReport(@Body() req:getMonthWisePurchaseRequest): Promise<Response> {
    try {
      return await this.grnService.getMonthWisePurchaseAnalysisReport(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(Response, error);
    }
  }
  @Post('/getDeffectsPurchaseAnalysis')
  async getDeffectsPurchaseAnalysis(@Body() req:BatchNumRequest): Promise<Response> {
    try {
      return await this.grnService.getDeffectsPurchaseAnalysis(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(Response, error);
    }
  }
  @Post('/getDeffectsLivePurchaseAnalysis')
  async getDeffectsLivePurchaseAnalysis(@Body() req:BatchNumRequest): Promise<Response> {
    try {
      return await this.grnService.getDeffectsLivePurchaseAnalysis(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(Response, error);
    }
  }
  @Post('/getTotalPackingPayablesDashboard')
  async getTotalPackingPayablesDashboard(@Body() req?:PayablesDashboardReq): Promise<CommonResponse> {
    try {
      return await this.grnService.getTotalPackingPayablesDashboard(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

    @Post('/getTotalPackingVendorPayables')
  async getTotalPackingVendorPayables(@Body() req?:any): Promise<CommonResponse> {
    try {
      return await this.grnService.getTotalPackingVendorPayables(req);
          } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getTotalPackingPaidsDashboard')
  async getTotalPackingPaidsDashboard(@Body() req?:PayablesDashboardReq): Promise<CommonResponse> {
    try {
      return await this.grnService.getTotalPackingPaidsDashboard(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getOverDuePackingRanges')
  async getOverDuePackingRanges(@Body() req?:PayablesDashboardReq): Promise<CommonResponse> {
    try {
      return await this.grnService.getOverDuePackingRanges(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getOverDuePackinginvoices')
  async getOverDuePackinginvoices(@Body() req?:PayablesDashboardReq): Promise<CommonResponse> {
    try {
      return await this.grnService.getOverDuePackinginvoices(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }


  @Post('/getTotalGeneralVendorPayables')
  async getTotalGeneralVendorPayables(@Body() req?:any): Promise<CommonResponse> {
    try {
      return await this.grnService.getTotalGeneralVendorPayables(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getPayablesViewData')
  async getPayablesViewData(@Body() req?:any): Promise<CommonResponse> {
    try {
      return await this.grnService.getPayablesViewData(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getTotalPackingPaidsReport')
  async getTotalPackingPaidsReport(@Body() req?:PayablesDashboardReq): Promise<CommonResponse> {
    try {
      return await this.grnService.getTotalPackingPaidsReport(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getUnitsForCeoDashboard')
  async getUnitsForCeoDashboard(): Promise<CommonResponse> {
    try {
      return await this.grnService.getUnitsForCeoDashboard();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
}
